<template>
  <div class="fund-invest-event-container">
    <InfoContainer
      :infoTitle="formOneConfig['infoTitle']"
      :contentConfig="formOneConfig['infoContent']"
      class="comment-container"    
    >
      <template #headerBtn>
        <el-button 
          type="primary"
          plain
          size="small"
          v-if="edit"
          @click="addOne(0)"
        >
          新增
        </el-button>
      </template>
      <template #basicInfo>
        <CommonTable
          :edit="edit"
          :tableData="tableOneData"
          :tableConfig="oneConfig"
          :sumIndex="[3]"
          @getSummaries="getOneSummaries"
          @handleEdit="handleEdit"
          @handleDetail="handleDetail"
        />
      </template>
    </InfoContainer>

    <InfoContainer
      :infoTitle="formTwoConfig['infoTitle']"
      :contentConfig="formTwoConfig['infoContent']"
      class="comment-container"    
    >
      <template #headerBtn>
        <el-button 
          type="primary"
          plain
          size="small"
          @click="addOne(1)"
          v-if="edit"
        >
          新增
        </el-button>
      </template>    
      <template #basicInfo>
        <CommonTable
          :edit="edit"
          :tableData="tableTwoData"
          :tableConfig="twoConfig"
          :sumIndex="[3, 4]"
          @handleEdit="handleEdit"
          @handleDetail="handleDetail"
        />
      </template>    
    </InfoContainer>

    <InfoContainer
      :infoTitle="formThreeConfig['infoTitle']"
      :contentConfig="formThreeConfig['infoContent']"
      class="comment-container"    
    >
      <template #headerBtn>
        <el-button 
          type="primary"
          plain
          size="small"
          @click="addOne(2)"
          v-if="edit"
        >
          新增
        </el-button>
      </template>    
      <template #basicInfo>
        <CommonTable
          :edit="edit"
          :tableData="tableThreeData"
          :tableConfig="threeConfig"
          :sumIndex="[1]"
          @handleEdit="handleEdit"
          @handleDetail="handleDetail"
        />
      </template>    
    </InfoContainer>

    <el-dialog
      :close-on-click-modal="false" 
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    
    width="75%"
    >
      <InvestEventAdd
        ref="eventAdd"
        :isDetail="isDetail"
        :id="$props.ids"
        :addType="addType"
        :eventBelongType="$props.eventBelongType"
        :eventId="eventId"
        @addSuccess="addSuccess"
      />
    </el-dialog>

  </div>
</template>
<script>
import { getList } from "@/api/fund/investeventmanage"; 
import InvestEventAdd from "@/components/fundComponent/investEventAdd"
import InfoContainer from "@/components/infoContainer/fundInfoContainer";
import CommonTable from "@/components/fundComponent/commonTable"
import { tableOneConfig, tableTwoConfig, tableThreeConfig } from "./cofig";
import { mapGetters } from "vuex";
export default {
  name: 'FundInvestEventManage',
  data() {
    return {
      isDetail: false,
      eventId: "",
      dialogVisible: false,
      dialogTitle: '',
      addType: "0",
      formData: '',
      tableOneData: [],
      oneConfig: tableOneConfig(this.getMoney),
      tableTwoData: [],
      twoConfig: tableTwoConfig(this.getMoney),
      tableThreeData: [],
      threeConfig: tableThreeConfig(this.getMoney),
      formOneConfig: {
        infoTitle: "投资动态-股权投资",
        showBtn: true,
        infoContent: [
          {
            title: "",
            prop: "basicInfo",
          },
        ],
      },
    
      formTwoConfig: {
        infoTitle: "投资动态-股权退出",
        showBtn: true,
        infoContent: [
          {
            title: "",
            prop: "basicInfo",
          },
        ],
      },
      
      formThreeConfig: {
        infoTitle: "投资动态-分红",
        showBtn: true,
        infoContent: [
          {
            title: "",
            prop: "basicInfo",
          },
        ],
      },

      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev,next",
        background: false,
        pageSize: 10,
      },      
    }
  },
  computed: {
    ...mapGetters(["permission"]),
  },
  components: {
    InvestEventAdd,
    InfoContainer,
    CommonTable
  },
  props: {
    edit: {
      type: Boolean,
      default: false
    },
    ids: {
      type:String,
      required: true
    },
    eventBelongType: {
      type: String,
      
      default:'1'
    }
  },
  watch:{
     ids:{
       handler(val){
           if(val>-1){
             this.getEventList()
           }
       }
     }
  },
  mounted() {
    this.getEventList()
  },
  methods: {
    handleDetail(data) {
      this.dialogTitle = data.eventType==0?'股权投资详情':data.eventType==1?'股权退出详情':'编辑分红详情'
      this.isDetail = true
      this.eventId = data.id
      this.addType = data.eventType
      this.dialogVisible = true
      if(this.$refs.eventAdd){
        this.$refs.eventAdd.startEvent()
      }
    },

    handleEdit(data) {
      this.dialogTitle = data.eventType==0?'编辑股权投资':data.eventType==1?'编辑股权退出':'编辑分红'
      this.isDetail = false
      this.eventId = data.id
      this.addType = data.eventType
      this.dialogVisible = true
      if(this.$refs.eventAdd){
        this.$refs.eventAdd.startEvent()
      }
    },

    addSuccess() {
      this.getEventList()
      this.dialogVisible = false
    },

    async getEventList() {
      let params={
        firstNum: (this.page.currentPage - 1) * this.page.pageSize,
        num: 100,
        projectId: this.ids
      }
      let res = await getList(params)
      this.tableOneData = res.data.data.records.filter(item => {return item.eventType == 0})
      this.tableTwoData = res.data.data.records.filter(item => {return item.eventType == 1})
      this.tableThreeData = res.data.data.records.filter(item => {return item.eventType == 2})
      this.$nextTick()
    },

    addOne(type) {
      this.isDetail = false
      this.dialogTitle = type==0?'新增股权投资':type==1?'新增股权退出':'新增分红'
      this.eventId = ''
      this.addType = type
      if(this.$refs.eventAdd){
        this.$refs.eventAdd.cleanData()
      }      
      this.dialogVisible = true
    },

  }
}
</script>
<style lang="scss" scoped>
.fund-invest-event-container{
  /deep/ .el-dialog__header {
    border-radius: 5px 5px 0px 0px;
    background-color: #fff;
      color: #333;
      border :1px solid  #e9e9e9 ;
      margin-bottom: 20px;
  }
  /deep/ .el-dialog__body {
    padding: 10px 20px 20px !important;
  }
}
/deep/.el-table__footer-wrapper {
   .cell {
     color:red
   }

}
/deep/ .el-table__header-wrapper,/deep/.el-table__fixed-header-wrapper {
   .cell {

    font-weight: 400 !important;
   }

}
</style>